import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { useFavorites } from '../context/FavoritesContext';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { favorites } = useFavorites();

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo" onClick={() => setOpen(false)}>
          Mis<span>XV</span><small>.com.mx</small>
        </Link>

        <button
          className="navbar-toggle"
          aria-label="Abrir menú"
          onClick={() => setOpen((v) => !v)}
        >
          ☰
        </button>

        <nav className={`navbar-links ${open ? 'open' : ''}`}>
          <NavLink to="/" end onClick={() => setOpen(false)}>Inicio</NavLink>
          <NavLink to="/categorias" onClick={() => setOpen(false)}>Categorías</NavLink>
          <NavLink to="/buscar" onClick={() => setOpen(false)}>Buscar</NavLink>
          <NavLink to="/blog" onClick={() => setOpen(false)}>Blog</NavLink>
          <NavLink to="/nosotros" onClick={() => setOpen(false)}>Nosotros</NavLink>
          <NavLink to="/favoritos" onClick={() => setOpen(false)} className="nav-favorites">
            ♥ Favoritos {favorites.length > 0 && <span className="fav-count">{favorites.length}</span>}
          </NavLink>
          <NavLink to="/login" onClick={() => setOpen(false)}>Iniciar sesión</NavLink>
          <Link to="/anunciate" className="btn btn-primary btn-nav" onClick={() => setOpen(false)}>
            Anúnciate
          </Link>
        </nav>
      </div>
    </header>
  );
}
